import { SocketMessageType, useSocketEvent } from '@aibees/shared/socket';
import { useGetSocketChannel } from '@aibees/shared/socket/hooks/use-get-socket-channel';
import {
  CompanyChangesSocketMessage,
  OnCompanyChangesSocketEvent,
} from '../types';

export function useSocketCompanyChanges(onEvent: OnCompanyChangesSocketEvent) {
  const channel = useGetSocketChannel(SocketMessageType.COMPANY_CHANGES);

  useSocketEvent(channel, (data: CompanyChangesSocketMessage) => {
    if (data.type === SocketMessageType.COMPANY_CHANGES) onEvent(data);
  });
}
